import React, { createContext, useContext, useState, useEffect } from "react";
import apiClient from "@/utils/api";

const SiteSettingsContext = createContext(null);

export const SiteSettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState({
    brand_name: "Anwer Fancy Lace",
    tagline: "Pakistan's Premium Lace Brand",
    phone_number: "+92 300 1234567",
    whatsapp_number: "+92 300 1234567",
    email: "info@anwerfancylace.pk",
    address: "Shop # 12, Main Lace & Cloth Market, Lahore, Pakistan",
    free_delivery_threshold: 5000,
    standard_delivery_charge: 250,
    bank_details: {
      bank_name: "Meezan Bank Ltd",
      account_title: "Anwer Fancy Lace",
      account_number: "0101-0103847593",
      iban: "PK36MEZN0001010103847593",
      branch: "Main Market Branch Lahore"
    },
    easypaisa_details: {
      account_name: "Anwer Fancy Lace",
      account_number: "0300-1234567"
    },
    jazzcash_details: {
      account_name: "Anwer Fancy Lace",
      account_number: "0300-1234567"
    },
    announcement_text: "✨ Free Cash on Delivery across Pakistan on orders above Rs. 5,000 | Wholesale & Retail Inquiries Welcome"
  });
  const [loading, setLoading] = useState(true);

  const fetchSettings = async () => {
    try {
      const { data } = await apiClient.get("/settings");
      if (data) {
        setSettings((prev) => ({ ...prev, ...data }));
      }
    } catch (e) {
      console.warn("Could not load dynamic settings, using defaults");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  return (
    <SiteSettingsContext.Provider value={{ settings, reloadSettings: fetchSettings, loading }}>
      {children}
    </SiteSettingsContext.Provider>
  );
};

export const useSiteSettings = () => useContext(SiteSettingsContext);
